import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import './Box.scss';
/**
 * Generic component for grouping other components and applying layout.
 */
export const Box = ({ alignItems, display, justifyContent, gap, height, width, p, pb, pl, pr, pt, px, py, m, mb, ml, mr, mt, mx, my, children, flexDirection, flexWrap, backgroundColor, ...props }) => {
    const className = useClassName({
        name: 'box',
        prefixed: true,
    }, alignItems && `items-${alignItems}`, justifyContent && `justify-${justifyContent}`, display, backgroundColor, flexDirection && `flex-${flexDirection}`, gap && `gap-${gap}`, 
    //padding
    p && `p-${p}`, pb && `pb-${pb}`, pl && `pl-${pl}`, pr && `pr-${pr}`, pt && `pt-${pt}`, px && `px-${px}`, py && `py-${py}`, 
    //margin
    m && `m-${m}`, mb && `mb-${mb}`, ml && `ml-${ml}`, mr && `mr-${mr}`, mt && `mt-${mt}`, mx && `mx-${mx}`, my && `my-${my}`, width && `w-${width}`, height && `h-${height}`, flexWrap && `flex-${flexWrap}`);
    return (_jsx("div", { ...props, className: className, children: children }));
};
